import { FC, useState } from 'react';
import { Typography, Box, TextField, Button, InputAdornment, IconButton } from '@mui/material';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import { StyledAuthForm, StyledAuthFormHeader } from './StyledAuthForm';

interface IFormData {
  email: string;
  password: string;
}

interface IProps {
  onSubmitHandler: (formData: IFormData) => void;
}

export const AuthForm: FC<IProps> = ({ onSubmitHandler }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormData>({
    defaultValues: {
      email: '',
      password: '',
    },
  });

  const [showPassword, setShowPassword] = useState(false);

  const onSubmit: SubmitHandler<IFormData> = ({ email, password }) => {
    onSubmitHandler({
      email,
      password,
    });
  };

  return (
    <StyledAuthForm>
      <StyledAuthFormHeader>
        <span />
      </StyledAuthFormHeader>
      <div className="content">
        <Typography
          align="center"
          sx={{
            lineHeight: '20px',
            fontWeight: 500,
            marginBottom: '15px',
          }}
        >
          Авторизируйтесь, чтобы войти
          <br />в личный кабинет
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit(onSubmit)}
        >
          <Controller
            name="email"
            control={control}
            rules={{
              required: 'Email is required',
              // pattern: {
              //   value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              //   message: 'Incorrect Email'
              // }
            }}
            render={({ field }) => (
              <TextField
                type="text"
                label="Email/номер телефона"
                placeholder=""
                fullWidth
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  marginBottom: '20px',
                }}
                error={errors.email && true}
                {...field}
              />
            )}
          />
          <Controller
            name="password"
            control={control}
            rules={{
              required: 'Password is required',
            }}
            render={({ field }) => (
              <TextField
                type={showPassword ? 'text' : 'password'}
                label="Пароль"
                placeholder=""
                fullWidth
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  marginBottom: '20px',
                }}
                error={errors.password && true}
                InputProps={{
                  style: {
                    paddingRight: 0,
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? <VisibilityOffOutlinedIcon /> : <RemoveRedEyeOutlinedIcon />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                {...field}
              />
            )}
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ marginBottom: '20px' }}
          >
            Войти
          </Button>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Typography
              align="center"
              sx={{
                fontWeight: 500,
                cursor: 'pointer',
              }}
            >
              Забыли пароль
            </Typography>
          </Box>
        </Box>
      </div>
    </StyledAuthForm>
  );
};
